import $ from 'jquery'

export default class disablePartnerLock {
    constructor (element) {
        this.$element = $(element)
        this.uri = this.$element.attr('href')
        this.$element.on('click', this.handleClick.bind(this))
    }

    handleClick (event) {
        event.preventDefault()
        const ajaxSettings = {
            url: this.uri,
            method: 'get',
            cache: false,
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            headers: {}
        }

        $.ajax(ajaxSettings)
            .always(() => {
                window.location.reload()
            })
    }
}
